import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Box, Button, Grid, Icon, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import PaginatedDataGrid from "components/PaginatedDataGrid";
import tagGroupsService from "services/tagGroups";
import { IFilterOptions } from "types/paginatedDataGrid";
import Basic from "pages/Login/Login";
import BasicLayout from "components/Layouts/BasicLayout";

const TagGroups: React.FC = () => {
  const [error, setError] = useState<any>(null);

  const columns: GridColDef[] = [
    {
      field: "thumbnail",
      headerName: "",
      width: 70,
      renderCell: (params: any) =>
        params.value ? (
          <img src={params?.value} alt="Tag Group" style={{ width: "50px" }} />
        ) : (
          <Icon
            baseClassName="material-icons-outlined"
            sx={{ fontSize: "50px !important", fontWeight: 100 }}
          >
            image
          </Icon>
        ),
      sortable: false,
    },
    { field: "title", headerName: "Title", flex: 1, minWidth: 200 },
    { field: "description", headerName: "Description", flex: 2, minWidth: 200 },
  ];

  const filterOptions: IFilterOptions = {
    title: true,
    tag: true,
  };

  return (
    <BasicLayout>
      <Grid container spacing={2}>
        <Grid item xs={5} display={"flex"} alignItems={"center"}>
          <Typography variant="h4">Tag Groups</Typography>
          {error && (
            <Typography variant="body1" color="error">
              {error}
            </Typography>
          )}
        </Grid>
        <Grid item xs={7} display={"flex"} justifyContent="flex-end" alignItems={"flex-end"}>
          <Button variant="contained" color="primary" component={Link} to="/tag-groups/create">
            <Icon>add</Icon>
            Create New
          </Button>
        </Grid>
        <Grid item xs={12}></Grid>

        <Grid item xs={12}>
          <Box>
            <PaginatedDataGrid
              collectionName="tag-groups"
              defaultSortField="title"
              defaultSortDirection="desc"
              columns={columns}
              service={tagGroupsService}
              filterOptions={filterOptions}
            />
          </Box>
        </Grid>
        <Grid item xs={12}></Grid>
      </Grid>
    </BasicLayout>
  );
};

export default TagGroups;
